export enum ContactResearchProviderId {
	Surfe = "surfe",
	Canada411 = "canada411",
	WebSearch = "webSearch",
	Hunter = "hunter",
}

export type ContactResearchInput = {
	firstName: string
	lastName: string
	contactAddress?: string | null
	contactMunicipality?: string | null
	contactProvince?: string | null
	contactPostalCode?: string | null
	contactLinkedInUrl?: string | null
	companyName?: string | null
	companyAddress?: string | null
	companyMunicipality?: string | null
	companyProvince?: string | null
	companyPostalCode?: string | null
	companyLinkedInUrl?: string | null
	companyDomain?: string | null
	companyPhone?: string | null
	companyNeq?: string | null
}

type ContactResearchSourceUrl = {
	url: string
	reason: string
}

type ContactResearchAdditionalInfo = {
	text: string
	sourceUrls: string[]
}

export enum ContactResearchInformationField {
	Email = "email",
	Phone = "phone",
	CompanyPhone = "companyPhone",
}

type ContactResearchInformationFound = {
	field: ContactResearchInformationField
	sourceUrl: string
}

export type ContactResearchContact = {
	fullName: string
	emails: string[]
	phones: string[]
	companyPhones: string[]
	linkedInUrl: string | null
	companyName: string | null
	jobTitle: string | null
	location: string | null
	source: string
	sourceUrls: ContactResearchSourceUrl[]
	informationFound?: ContactResearchInformationFound[]
	additionalInfos: ContactResearchAdditionalInfo[]
}

export type ContactResearchProviderInfo = {
	id: ContactResearchProviderId
	label: string
	description: string
	requiresCompany: boolean
}

export enum ContactResearchProviderStatus {
	Success = "success",
	Empty = "empty",
	Error = "error",
	Skipped = "skipped",
}

export type ContactResearchProviderResult = {
	provider: ContactResearchProviderId
	label: string
	status: ContactResearchProviderStatus
	durationMs: number
	logs: string[]
	contacts: ContactResearchContact[]
	sanitizedContacts: ContactResearchContact[]
	error: string | null
}

export type ContactResearchResult = {
	input: ContactResearchInput
	providers: ContactResearchProviderResult[]
	contacts: ContactResearchContact[]
	sanitizedContacts: ContactResearchContact[]
	startedAt: string
	completedAt: string
}

export enum ContactResearchEventType {
	RunStarted = "runStarted",
	ProviderStarted = "providerStarted",
	ProviderLog = "providerLog",
	ProviderOutputDelta = "providerOutputDelta",
	ProviderCompleted = "providerCompleted",
	RunCompleted = "runCompleted",
	RunFailed = "runFailed",
}

export type ContactResearchEvent =
	| {
			type: ContactResearchEventType.RunStarted
			runId: string
			input: ContactResearchInput
			providers: ContactResearchProviderInfo[]
			timestamp: string
	  }
	| {
			type: ContactResearchEventType.ProviderStarted
			runId: string
			provider: ContactResearchProviderInfo
			timestamp: string
	  }
	| {
			type: ContactResearchEventType.ProviderLog
			runId: string
			provider: ContactResearchProviderId
			message: string
			timestamp: string
	  }
	| {
			type: ContactResearchEventType.ProviderOutputDelta
			runId: string
			provider: ContactResearchProviderId
			delta: string
			timestamp: string
	  }
	| {
			type: ContactResearchEventType.ProviderCompleted
			runId: string
			result: ContactResearchProviderResult
			timestamp: string
	  }
	| {
			type: ContactResearchEventType.RunCompleted
			runId: string
			result: ContactResearchResult
			timestamp: string
	  }
	| { type: ContactResearchEventType.RunFailed; runId: string; error: string; timestamp: string }

export enum ContactResearchProviderProgressStatus {
	Pending = "pending",
	Running = "running",
}

export enum ContactResearchRunStatus {
	Idle = "idle",
	Running = "running",
	Completed = "completed",
	Failed = "failed",
}

export type ContactResearchProviderProgress = {
	provider: ContactResearchProviderInfo
	status: ContactResearchProviderProgressStatus | ContactResearchProviderStatus
	logs: Array<{ message: string; timestamp: string }>
	output: string
	result: ContactResearchProviderResult | null
	startedAt: string | null
}
